import { render, staticRenderFns } from "./AdmitDetailsFields.vue?vue&type=template&id=222556b7&"
import script from "./AdmitDetailsFields.vue?vue&type=script&lang=ts&"
export * from "./AdmitDetailsFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports